<div class="w-100 position-absolute d-flex align-items-center justify-content-center gap-3 start-0 tr-single-line-main">
	<span class="tr-small-line" [style.width.%]="width"></span>
</div>